import React, { useState, useEffect } from "react";
import {
  attendantColor,
  initials as initialsOf,
} from "../../CrmKanban/kanban/tokens";

// Avatar do contato: mostra a foto (profilePicUrl) e cai p/ iniciais coloridas
// se não houver URL ou a imagem falhar (URLs do WhatsApp expiram).
const Avatar = ({ url, name, size, radius, fontSize = 13 }) => {
  const [broken, setBroken] = useState(false);

  // Reseta o fallback quando a URL muda (troca de contato).
  useEffect(() => {
    setBroken(false);
  }, [url]);

  const base = {
    width: size,
    height: size,
    borderRadius: radius,
    flex: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  if (url && !broken) {
    return (
      <img
        src={url}
        alt={name || ""}
        onError={() => setBroken(true)}
        style={{ ...base, objectFit: "cover", background: "#e9edf2" }}
      />
    );
  }

  return (
    <span
      style={{
        ...base,
        background: attendantColor(name),
        color: "#fff",
        fontSize,
        fontWeight: 800,
      }}
    >
      {initialsOf(name)}
    </span>
  );
};

export default Avatar;
